import mapperIcon from '../data-layer/utils/mappers/mapper-icon'

export const useFilters = (emit: Function) => {
  const router = useRouter()
  const filters = useState('filters-filters', () => ([]))
  const query = useState('filters-query', () => '')

  const getIcon = (icon, defaultIcon) => {
    if (!icon && defaultIcon) {
      return defaultIcon
    }
    return icon
  }

  const getFilterValue = (filterName, multiple: boolean, initialFilter) => {
    // InitialFilter -> in this case, the user may select a filter from the knowledge hub homepage that will direct them to the articles page with a query parameter
    // Prior to this addition this value never gets passed into the getFilterValue method, so the select boxes never showed which filters were selected.
    if (initialFilter) {
      return initialFilter?.find(i => i.name === filterName)?.value
    }

    const value = multiple ? [] : ''
    return filters.value?.find(i => i.name === filterName)?.value || value
  }

  const normalizeExternalFilterOptions = (items, defaultIcon) => {
    return items?.map((item) => {
      const icon = item.icon ? getIcon(item?.icon, defaultIcon) : null
      return {
        id: item.id,
        text: item.name,
        value: item.id,
        ...icon && { icon: mapperIcon(icon) }
      }
    }) || []
  }

  const removeFilter = (filterName) => {
    const filters_ = [...filters.value]
    // get filter index and remove item from array
    const index = filters_.findIndex(({ name }) => name === filterName)
    if (index !== -1) {
      filters_.splice(index, 1)
    }
    filters.value = filters_
  }

  const resetFilters = () => {
    filters.value = []
  }

  const normalizeKnowledgeHubFilterOptions = (items, defaultIcon) => {
    return items?.map((item) => {
      const icon = getIcon(item?.icon, defaultIcon)
      return {
        id: item?.sys?.id,
        text: item.name,
        value: item?.sys?.id,
        ...icon && { icon: mapperIcon(icon) }
      }
    })
  }

  const setFilter = (filterName, filterValue) => {
    const filters_ = [...filters.value]
    const index = filters_.findIndex(({ name }) => name === filterName)
    // filter exists and value is empty
    if ((filterValue === '' || filterValue.length === 0) && index !== -1) {
      // remove item from array
      filters_.splice(index, 1)
    } else if (index !== -1) {
      // filter exists update value
      filters_.splice(index, 1, { name: filterName, value: filterValue })
    } else {
      // new filter push value
      filters_.push({ name: filterName, value: filterValue })
    }
    filters.value = filters_
  }

  // Use unsafe flag if text might contain slashes
  const handleSearch = (value: any) => {
    query.value = value
    emit('search', value)
  }

  return {
    getFilterValue,
    normalizeExternalFilterOptions,
    setFilter,
    handleSearch,
    filters,
    query,
    resetFilters,
    normalizeKnowledgeHubFilterOptions,
    removeFilter
  }
}
